






















import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { IDialog } from '@models';

@Component
export default class AlertDialog extends Vue {
  name = 'alertDialog';
  @Prop({ type: Object as () => IDialog })
  public dialogModel!: IDialog

  ok() {
    this.dialogModel.ok();
  }

  cancel() {
    this.dialogModel.cancel();
  }
}
